export const noCardBoxShadow = `
  &, &:hover, &:focus {
    box-shadow: none !important;
  }
`;

export const linkNoHoverColor = `
  color: #0078d4;
  &:hover, &:focus {
    color: #0078d4;
    text-decoration: underline;
  }
`;

export const restingStyle = `
border-radius: 0px;
text-align: left;
padding: 0;
border-image: none;
background-color: white;
box-sizing: border-box;
box-shadow: rgba(0, 0, 0, 0.13) 0px 1.6px 3.6px 0px,
  rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px;
margin: 0px;
width: 100%;
min-height: 100%;
border: none;
cursor: pointer;`;

export const defaultCardStyle = `
  ${restingStyle}
  :hover,
  :focus {
    box-shadow: 0 6.4px 14.4px 0 rgba(0, 0, 0, 0.13),
      0 1.2px 3.6px 0 rgba(0, 0, 0, 0.11) !important;
  }
  :focus {
    outline: 1px solid black;
  }
  &:hover .highlight-on-card-hover,
  &:focus .highlight-on-card-hover {
    color: #0062af;
    text-decoration: underline;
  }
`;
